import { props } from '@ngrx/store';
import { CxbActionTriplet } from '../core/cxb-action-triplet';
import { PageItemType } from '../domain/page-item-type';
import { PageVersion, PageVersionUpdateProps } from '../domain/page-version';
import { Tenant } from '../domain/tenant';
import { PageType } from './page-type';

const feature = '[CXB Page Edit Screen]';

export const loadCxbPageEditScreen = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Load page edit screen`,
  props<{ pageVersionId: string; userSegments: string[]; countryCodes: string[]; pageType: PageType; selectedTenant: Tenant }>(),
  props<{ page: PageVersion }>()
);

export const publishCxbPageDraft = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Publish page draft`,
  props<{ pageId: string; pageType: PageType }>(),
  props<{ pageType: PageType }>()
);

export const deleteCxbPageDraft = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Delete page draft`,
  props<{ pageId: string; pageType: PageType }>(),
  props<{ pageType: PageType }>()
);

export const unpublishCxbPage = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Unpublish page`,
  props<{ pageId: string; pageType: PageType }>(),
  props<{ pageType: PageType }>()
);

export const deleteCxbPageItem = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Delete page item`,
  props<{ pageVersionId: string; pageType: PageType; id: string; trayType: PageItemType }>(),
  props<{ pageVersionId: string; pageType: PageType }>()
);

export const cloneCxbPageItem = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Clone page item`,
  props<{ pageVersionId: string; id: string; trayType: PageItemType; pageType: PageType; targetPageId: string }>(),
  props<{ pageVersionId: string; id: string; trayType: PageItemType; pageType: PageType; targetPageId: string }>()
);

export const createCxbPageDraft = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Create page draft`,
  props<{ pageId: string; pageType: PageType }>(),
  props<{ draftPageVersionId: string; pageType: PageType }>()
);

export const updateCxbPageVersion = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Update page version`,
  props<{ pageVersion: PageVersionUpdateProps; pageType: PageType }>(),
  props<{ pageVersionId: string; pageType: PageType }>()
);

export const updateCxbRedeemPageVersion = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Update redeem page version`,
  props<{
    pageVersion: Pick<PageVersionUpdateProps, 'id' | 'metaTags' | 'internalName' | 'titleEnglish' | 'titleArabic'>;
    countryIds: string[];
    userSegmentIds: string[];
  }>(),
  props<{ pageVersionId: string; pageType: PageType }>()
);

export const updateCxbPageItems = CxbActionTriplet.withAllProps(
  `${feature} Update page items order`,
  props<{ pageVersionId: string; items: { id: string; order?: number; visible?: boolean }[]; pageType: PageType }>(),
  props<{ page: PageVersion }>(),
  props<{
    errorMessage: string;
    extras: { pageVersionId: string; userSegments: string[]; countryCodes: string[]; pageType: PageType; selectedTenant: Tenant };
  }>()
);
